/**
@license
Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/

import {
  REDIRECT,
  UPDATE_PAGE,
  UPDATE_OFFLINE,
  OPEN_SNACKBAR,
  CLOSE_SNACKBAR,
  UPDATE_LAYOUT,
  SET_CALLBACK_URL,
  SET_CLIENT,
  SET_LOCALE,
} from '../actions';

export const app = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_PAGE:
      return {
        ...state,
        page: action.page,
        tail: action.tail,
      };
    case REDIRECT:
      return {
        ...state,
        redirection: action.redirection,
      };
    case SET_CALLBACK_URL:
      return {
        ...state,
        callbackUrl: action.callbackUrl,
      };
    case SET_CLIENT:
      return {
        ...state,
        client: action.client,
      };
    case SET_LOCALE:
      return {
        ...state,
        locale: action.locale,
      };
    case UPDATE_OFFLINE:
      return {
        ...state,
        offline: action.offline,
      };
    case OPEN_SNACKBAR:
      return {
        ...state,
        snackbarOpened: true,
      };
    case CLOSE_SNACKBAR:
      return {
        ...state,
        snackbarOpened: false,
      };
    case UPDATE_LAYOUT:
      return {
        ...state,
        wideScreen: action.wideScreen,
      };
    default:
      return state;
  }
};
